import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LanguagesService } from '../../../../services/shared/languages.service';
import { UploadEmployeesService } from '../../../../services/shared/upload-employees.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogLogsComponent } from '../dialog-logs/dialog-logs.component';
import { CrudService } from 'src/app/services/shared/crud.service';
import { Country } from 'src/app/models/country';
import { LoaderService } from '@ff/loader';
import { UtilsService } from '../../../../services/shared/utils.service';
import { User } from 'src/app/models/user';
import { UserService } from '@ff/user';
import { DialogImportHistoryComponent } from '../dialog-import-history/dialog-import-history.component';

@Component({
  selector: 'app-employees-uploader',
  templateUrl: './employees-uploader.component.html',
  styleUrls: ['./employees-uploader.component.scss']
})
export class EmployeesUploaderComponent implements OnInit {

  @Input() docId: string;
  @ViewChild('fileSelector') fileSelector: ElementRef;

  documentForm: FormGroup;


  selectedFile: File=undefined;
  progress = 0;
  fileInfos: Observable<any>;
  countries: Country[] = [];
  user: User;
  isSuperAdmin: boolean = false;




  constructor(
    private fb: FormBuilder,
    private langService: LanguagesService,
    private uploadFileService: UploadEmployeesService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private crudService: CrudService,
    private loaderService: LoaderService,
    private utilsService: UtilsService,
    private userService: UserService,
    private translateService: TranslateService,
    private dialog: MatDialog
  ) { }



  ngOnInit(): void {

    this.user = new User(this.userService.getUser().getValue());
    this.isSuperAdmin = this.user.isSuperAdmin();
    this.initForm();

    this.refreshCountries();

  }

  initForm(): void {

    this.documentForm = this.fb.group({
      file: [null, []],
      country: [null, []]
    });

    
  }

  get currentLang(): string {
		return this.translateService.currentLang;
	}

	refreshCountries(): void {
		if (this.user.isSuperAdmin()) {
			this.crudService.getCountries().subscribe((countries: Country[]) => {
				this.countries = countries;
			});
		} else {
      this.documentForm.get('country').setValue(this.user.admin_country.id);
      this.countries = [this.user.admin_country];
		}
	}

  downloadFile(): void {
    this.fileSelector.nativeElement.click();
  }

  downloadDocument(event): void {
   
    this.selectedFile = event.target.files[0];
    console.log('downloadDocument',this.selectedFile);  
  }



  onSelectCountry($event): void {
    console.log('onCountryChange', $event);
    
  }

  onExportTemplate(): void {
    const country_id = this.documentForm.get('country').value;
    if(country_id){
      this.exportEmployeesTemplate(country_id);
    }
  }

  onOpenImportHistoryDialog(): void {
    const country_id = this.documentForm.get('country').value;
    this.loaderService.show();
    if(country_id){
      const country=this.countries.find(country => country.id === country_id) ;
      this.uploadFileService.getImportHistory(country_id).subscribe((res) => {
      this.loaderService.hide();
      this.openImportHistorDialog((country as any)?.label_en,res);
        console.log('logs:', res);

      }, error => {
        this.loaderService.hide();
        this.snackBar.open(error);
      });
    }
  }

  exportEmployeesTemplate(country_id): void {
		this.loaderService.show();
    const selectedCountry = country_id ? this.countries.find(country => country.id === country_id) : null;
		this.uploadFileService.exportTemplate(country_id).subscribe((res) => {
			this.utilsService.exportTemplateXlsx(res, (selectedCountry as any)?.label_en);
			this.loaderService.hide();
		}, error => {
			this.loaderService.hide();
			this.snackBar.open(error);
		});
	}

  exportLastImportedFile(country_id): void {
		this.loaderService.show();
    const selectedCountry = country_id ? this.countries.find(country => country.id === country_id) : null;
		this.uploadFileService.exportLastImportedFile(country_id).subscribe((res) => {
			this.utilsService.exportTemplateXlsx(res, (selectedCountry as any)?.label_en);
			this.loaderService.hide();
		}, error => {
			this.loaderService.hide();
			this.snackBar.open(error);
		});
	}


  openLogDialog(item): void {

    const dialogRef = this.dialog.open(DialogLogsComponent, {
      width: '1200px',
      data: { item:item }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openImportHistorDialog(country_name,history): void {
    
    const dialogRef = this.dialog.open(DialogImportHistoryComponent, {
      width: '1200px',
      data: { history: history,country_name:country_name }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  uploadFile(): void {
    this.progress = 0;
    if(!this.selectedFile){
      this.snackBar.open(this.translate.instant('please select a file'));
      return;
    }
    console.log('this.selectedFile----->', this.selectedFile);
    this.uploadFileService.upload(this.selectedFile).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          const logs=event?.body?.data;
          console.log('event:', event);
          if (logs){
            this.snackBar.open(this.translate.instant('documents.upload_ok'));
            this.openLogDialog(event?.body?.data);
          }else{
            const message=event?.body?.message ?? 'documents.upload_ko';
            this.snackBar.open(this.translate.instant(message));
          }
          //this.cancelFile();
        }
      },
      (err) => {
        if (err.status === 401) {
          window.location.reload();
        } else {
          console.log('error:', err);
          const message=err?.error?.message ?? 'documents.upload_ko';
          this.snackBar.open(this.translate.instant(message));
          //this.cancelFile();
        }
      });
  }

  cancelFile(): void {
    this.selectedFile = undefined;
     this.progress = 0;
  }

}
